const hardCodedFeatureFlags = {
	distributeMultipleArticles: true,
};

export default hardCodedFeatureFlags;
